import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { PortfolioAssetDetailsResponse } from '../../models';
import * as actions from './portfolio-holdings-resolution.actions';

export interface PortfolioHoldingsResolutionState extends EntityState<PortfolioAssetDetailsResponse> { }

export function selectRequestID(assetDetailsResponse: PortfolioAssetDetailsResponse): string {
	return assetDetailsResponse.requestId;
}

const adapter: EntityAdapter<PortfolioAssetDetailsResponse> = createEntityAdapter<PortfolioAssetDetailsResponse>({
	selectId: selectRequestID
});

export const initialHoldingsResolutionState: PortfolioHoldingsResolutionState = adapter.getInitialState();

const {
	selectAll
} = adapter.getSelectors();

export const selectAllPortfolioAssetDetailsResponse = selectAll;

const responseReducer = createReducer(
	initialHoldingsResolutionState,
	on(actions.setAllPortfolioAssetDetailsResponses, (state, { portfolioAssetDetailsResponses }) => {
		return adapter.setAll(portfolioAssetDetailsResponses, state);
	})
);

const storeReducer = createReducer(
	initialHoldingsResolutionState
);

export function portfolioHoldingsResolutionReducer(state: PortfolioHoldingsResolutionState | undefined, action: Action): PortfolioHoldingsResolutionState {
	return storeReducer(state, action);
}

export function portfolioAssetDetailsResponsesReducer(state: PortfolioHoldingsResolutionState | undefined, action: Action): EntityState<PortfolioAssetDetailsResponse> {
	return responseReducer(state, action);
}
